var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout_c"},[_c('div',{staticClass:"top"},[_c('top')],1),_c('div',{staticClass:"member-right-navbar-index"},[_c('app-main',{staticClass:"main"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }